export default __webpack_public_path__ + "static/media/swiss_flag.933386a5.png";